import { styled } from '@mui/material';
import React, { ReactNode } from 'react';
import color from 'styles/color';
import { RootStyle } from './style';

const TabRow = styled('div')<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  background-color: ${({ active }) => (active ? color.blue05 : color.white)};
  border-radius: 4px;
  color: ${({ active }) => (active ? color.white : color.gray08)};
  border: ${({ active }) => (active ? 'none' : '1px solid #dee2e6')};
`;
interface IProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

export function Tab({ label, active, onClick }: IProps) {
  return (
    <TabRow onClick={onClick} active={active}>
      {label}
    </TabRow>
  );
}
